import { useCallback } from "react";
import { transformToFloat } from "../../../lib/transformToFloat";

export const useScheduleRules = () => {
  const getScheduleRules = useCallback((scheduleValues: any) => {
    const scheduledSettings = scheduleValues
      ? {
          ...scheduleValues,
          scheduledDate: scheduleValues.scheduledDate.format(),
        }
      : null;

    if (scheduledSettings) {
      if (scheduledSettings.endDate) {
        scheduledSettings.endDate = scheduleValues.endDate.format();
      }

      if (scheduledSettings.maxOccurrences) {
        scheduledSettings.maxOccurrences = transformToFloat(
          scheduledSettings.maxOccurrences,
        );
      } else {
        delete scheduledSettings.maxOccurrences;
      }
    }

    return scheduledSettings;
  }, []);

  return { getScheduleRules };
};
